import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useStoreState } from "pullstate";
import { subscribeUserNotification } from "../../utils/pushNotification";
import InApppAlert from "../InAppAlert";
import Store from "../../utils/Store";
import { get, isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import constants from "../../utils/constants";
import { differenceInMilliseconds } from "date-fns";
import { getFCMToken } from "../../utils";
import { useTranslation } from "react-i18next";
import useSaveNotificationSettings from "../NotificationSettings/hooks/useSaveNotificationSettings";
import Toast from "../Toast";
import useAuthService from "../../hooks/useAuthService";
import Loader from "../Loader";
import { useRouter } from "next/router";
import LoggedInToken from "../../utils/LoggedInToken";
var NotificationSubscription = function NotificationSubscription() {
  var _window, _window2, _window3;
  var isMobileApp = (_window = window) === null || _window === void 0 ? void 0 : _window.ReactNativeWebView;
  var isDesktopApp = (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.electronAPI;
  var isApp = isMobileApp || isDesktopApp;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var router = useRouter();
  var _useState = useState(!!localStorage.getItem(constants.PERSISTED.notificationPromptDismiss)),
    isIgnored = _useState[0],
    setIgnored = _useState[1];
  var saveNotificationSettings = useSaveNotificationSettings();
  var _useAuthService = useAuthService(false),
    refetchProfile = _useAuthService.refetch;
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        user: s.user,
        userInfo: s.userInfo,
        RNfcmToken: s.RNfcmToken,
        isRNAppStateChange: s.isRNAppStateChange,
        RNAppVersion: s.RNAppVersion,
        fcmToken: s.fcmToken,
        isNotificationSubscribing: s.isNotificationSubscribing
      };
    }),
    user = _useStoreState.user,
    userInfo = _useStoreState.userInfo,
    fcmToken = _useStoreState.fcmToken,
    RNfcmToken = _useStoreState.RNfcmToken,
    isRNAppStateChange = _useStoreState.isRNAppStateChange,
    isNotificationSubscribing = _useStoreState.isNotificationSubscribing;
  var token = RNfcmToken || fcmToken;
  var isLoggedIn = !isEmpty(user);
  var hasPermission = isMobileApp && (!!RNfcmToken || RNfcmToken === "") || ((_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.Notification) === null || _window3 === void 0 ? void 0 : _window3.permission) === "granted";
  var isNotificationsOn = !isLoggedIn || !get(userInfo, ["settings", "notification_snoozed"], false);
  var isSubscribed = isNotificationSubscribing || !isLoggedIn && hasPermission || !token && hasPermission || get(userInfo, ["subscription_tokens"], []).some(function (tokenObj) {
    return get(tokenObj, ["token"], "") === token;
  });
  var alertTimeout;
  useEffect(function () {
    if (isLoggedIn) {
      setDefaultFCMTokens();
      setAlertTimer();
      if (LoggedInToken.isLoginProgress()) {
        LoggedInToken.removeLogInProgress();
        updateSubscription();
      }
    }
    return function () {
      clearTimeout(alertTimeout);
    };
  }, [isLoggedIn]);

  // when user change the notification permission of app from device settngs
  useEffect(function () {
    if (isMobileApp && isRNAppStateChange && isLoggedIn) {
      var _hasPermission2 = !!RNfcmToken;
      if (!hasPermission && _hasPermission2) {
        updateSubscription();
      }
    }
  }, [RNfcmToken, isRNAppStateChange]);

  // To nudge users every 6  hours if user has ignored the popup and not enabled notification yet
  var setAlertTimer = function setAlertTimer() {
    if (hasPermission && isSubscribed && isNotificationsOn) {
      return localStorage.removeItem(constants.PERSISTED.notificationPromptDismiss);
    }
    var timeStr = localStorage.getItem(constants.PERSISTED.notificationPromptDismiss);
    if (timeStr) {
      var _ignoredTime = new Date(timeStr);
      _ignoredTime.setHours(_ignoredTime.getHours() + 12);
      var _remainingTime = differenceInMilliseconds(_ignoredTime, new Date());
      alertTimeout = setTimeout(function () {
        clearTimeout(alertTimeout);
        localStorage.removeItem(constants.PERSISTED.notificationPromptDismiss);
        setIgnored(false);
      }, _remainingTime);
    }
  };

  // check if user is subscribed for notification
  var setDefaultFCMTokens = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _window4;
      var _fcmToken2;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(((_window4 = window) === null || _window4 === void 0 || (_window4 = _window4.Notification) === null || _window4 === void 0 ? void 0 : _window4.permission) === "granted")) {
                _context.next = 5;
                break;
              }
              _context.next = 3;
              return getFCMToken();
            case 3:
              _fcmToken2 = _context.sent;
              Store.update(function (s) {
                s.fcmToken = _fcmToken2;
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function setDefaultFCMTokens() {
      return _ref.apply(this, arguments);
    };
  }();
  var onIgnore = function onIgnore() {
    if (isNotificationSubscribing) {
      return;
    }
    clearTimeout(alertTimeout);
    localStorage.setItem(constants.PERSISTED.notificationPromptDismiss, new Date().toString());
    setIgnored(true);
    setAlertTimer();
  };
  var updateSubscription = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var subscription;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              Store.update(function (s) {
                s.isNotificationSubscribing = true;
              });
              _context2.next = 3;
              return subscribeUserNotification(RNfcmToken);
            case 3:
              subscription = _context2.sent;
              if (!subscription) {
                _context2.next = 7;
                break;
              }
              _context2.next = 7;
              return refetchProfile();
            case 7:
              Store.update(function (s) {
                s.isNotificationSubscribing = false;
              });
            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function updateSubscription() {
      return _ref2.apply(this, arguments);
    };
  }();
  var enableGlobalNotifications = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return saveNotificationSettings.mutateAsync({
                notification_snoozed: false
              });
            case 3:
              refetchProfile();
              _context3.next = 9;
              break;
            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](0);
              Toast.error("Something went wrong. Please try again");
            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 6]]);
    }));
    return function enableGlobalNotifications() {
      return _ref3.apply(this, arguments);
    };
  }();
  var onEnableNotification = function onEnableNotification() {
    if (isNotificationSubscribing) {
      return;
    }
    if (isMobileApp && !hasPermission) {
      var _window5;
      var _data = {
        event: constants.RN_COMM_CONST.OPEN_APP_SETTINGS,
        data: null
      };
      (_window5 = window) === null || _window5 === void 0 || (_window5 = _window5.ReactNativeWebView) === null || _window5 === void 0 ? void 0 : _window5.postMessage(JSON.stringify(_data));
    } else if (isSubscribed && !isNotificationsOn) {
      enableGlobalNotifications();
    } else {
      updateSubscription();
    }
  };
  return /*#__PURE__*/React.createElement(InApppAlert, {
    show: !isNotificationSubscribing && router.pathname != "/open-app" && isLoggedIn && !isIgnored && (!hasPermission || !isSubscribed || !isNotificationsOn),
    message: !hasPermission || !isSubscribed ? t("notification_modal.no_notifications_setting") : t("notification_modal.no_notifications"),
    primaryCTA: /*#__PURE__*/React.createElement("a", {
      className: "text-teal-500 cursor-pointer",
      onClick: onEnableNotification
    }, isMobileApp && !hasPermission ? t("notification_modal.enable_settings") : t("notification_modal.turn_on_notification")),
    secondaryCTA: /*#__PURE__*/React.createElement("a", {
      className: "text-gray-600 cursor-pointer",
      onClick: onIgnore
    }, t("notification_modal.ignore")),
    className: "",
    icon: isNotificationSubscribing ? /*#__PURE__*/React.createElement(Loader, {
      size: "medium",
      className: "border-teal-200"
    }) : /*#__PURE__*/React.createElement("svg", {
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M22.1437 4.25V5.50719C26.9989 6.31648 30.7156 10.7328 30.7156 16.0625V18.4109C30.7156 21.6031 31.7536 24.7039 33.6488 27.2L34.6466 28.5078C35.035 29.0141 35.1086 29.7102 34.8408 30.2938C34.5729 30.8773 34.0104 31.25 33.3943 31.25H6.60723C5.98912 31.25 5.42626 30.8773 5.15866 30.2938C4.89099 29.7102 4.96626 29.0141 5.35226 28.5078L6.35075 27.2C8.25062 24.7039 9.28594 21.6031 9.28594 18.4109V16.0625C9.28594 10.7328 13.0026 6.31648 17.8578 5.50719V4.25C17.8578 3.00758 18.8154 2 20.0008 2C21.1861 2 22.1437 3.00758 22.1437 4.25ZM19.465 8.75C15.6211 8.75 12.5004 12.0266 12.5004 16.0625V18.4109C12.5004 21.7789 11.5709 25.0625 9.84244 27.875H30.1597C28.432 25.0625 27.5011 21.7789 27.5011 18.4109V16.0625C27.5011 12.0266 24.3804 8.75 20.5365 8.75H19.465ZM24.2867 33.5C24.2867 34.632 23.838 35.8414 23.0344 36.6852C22.2308 37.5289 21.0789 38 20.0008 38C18.8623 38 17.7707 37.5289 16.9671 36.6852C16.1635 35.8414 15.7148 34.632 15.7148 33.5H24.2867Z",
      fill: "#00D0CD"
    }))
  });
};
export default NotificationSubscription;